
import * as ipxRuntime$be0rI6_45w8t1DhY8NqM2P29yoKgN5HTPBjNgauYGWD8A from '/var/www/2025-05-06_07_36/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$be0rI6_45w8t1DhY8NqM2P29yoKgN5HTPBjNgauYGWD8A, defaults: {} }
}
        